import * as React from 'react'

export const HomeView: React.FC = () => <>&nbsp;</>
